import { useIntl } from 'react-intl';

import { Hint } from 'components/hint/Hint';

export type SortArrowsProps = {
  direction?: 'ASC' | 'DESC';
  onAsc?: () => void;
  onDesc?: () => void;
  size?: string;
  column?: 'ID' | 'NAME' | 'EMAIL' | 'ROLE' | 'LAST_LOGIN';
};

export function SortArrows({
  direction,
  onAsc,
  onDesc,
  size = '12px',
  column = 'ID',
}: SortArrowsProps) {
  const intl = useIntl();

  const USERS_FORM_SORT_KEYS = {
    ID: 'USERS.FORM.SORT.ID',
    NAME: 'USERS.FORM.SORT.NAME',
    EMAIL: 'USERS.FORM.SORT.EMAIL',
    ROLE: 'USERS.FORM.SORT.ROLE',
    LAST_LOGIN: 'USERS.FORM.SORT.LAST_LOGIN',
  };
  const colKey = column?.toUpperCase() as keyof typeof USERS_FORM_SORT_KEYS;
  const colMsgId = USERS_FORM_SORT_KEYS[colKey] || USERS_FORM_SORT_KEYS.ID;

  return (
    <span
      style={{
        marginLeft: 8,
        display: 'inline-flex',
        flexDirection: 'column',
        verticalAlign: 'middle',
      }}
    >
      <Hint
        hint={
          intl.formatMessage({ id: colMsgId }) +
          ', ' +
          intl.formatMessage({ id: 'USERS.FORM.SORT.ASC' })
        }
        placement="right"
      >
        <button
          type="button"
          style={{
            border: 'none',
            background: 'none',
            padding: 0,
            cursor: 'pointer',
            lineHeight: 1,
            color: direction === 'ASC' ? 'black' : '#aaa',
            fontSize: size,
          }}
          aria-label="Sort ascending"
          onClick={onAsc}
        >
          ▲
        </button>
      </Hint>
      <Hint
        hint={
          intl.formatMessage({ id: colMsgId }) +
          ', ' +
          intl.formatMessage({ id: 'USERS.FORM.SORT.DESC' })
        }
        placement="right"
      >
        <button
          type="button"
          style={{
            border: 'none',
            background: 'none',
            padding: 0,
            cursor: 'pointer',
            lineHeight: 1,
            color: direction === 'DESC' ? 'black' : '#aaa',
            fontSize: size,
          }}
          aria-label="Sort descending"
          onClick={onDesc}
        >
          ▼
        </button>
      </Hint>
    </span>
  );
}
